import styles from "@website/ui/top-app-bar/top-app-bar.module.scss";
import { TopAppBarPropertiesType } from "@website/ui/top-app-bar/top-app-bar.types";
import { FC, memo } from "react";

const TopAppBar: FC<TopAppBarPropertiesType> = (properties) => {
  const { StartAction, title, EndAction, className } = properties;

  return (
    <div className={`${styles["container"]} ${className || ""}`}>
      {StartAction}
      <div className={styles["title"]}>{title}</div>
      {EndAction}
    </div>
  );
};

const TopAppBarMemoized = memo(TopAppBar);
export { TopAppBarMemoized as TopAppBar };
